<template>
  <div>

    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-user"></i> {{ (!showAccountNumber) ? 'Total ' +bankAccountNumbers.toLocaleString() + ' Accounts' : 'Bank Account'  }}</span>

      </div>
      <el-row :gutter="15" class="panel-group">
        <el-col :xs="24" :sm="12" :lg="6" class="card-panel-col" v-if="showAccountNumber">
          <div class="card-panel">
            <div class="card-panel-icon-wrapper icon-people">
              <svg-icon icon-class="peoples" class-name="card-panel-icon" />
            </div>
            <div class="card-panel-description">
              <div class="card-panel-text">Account</div>
              <!-- <count-to :start-val="0" :end-val="102400" :duration="2600" class="card-panel-num" /> -->
              <div class="card-panel-num">
                {{ bankAccountNumbers.toLocaleString() }}
              </div>
            </div>
          </div>
        </el-col>
        <el-col
          :xs="24"
          :sm="12"
          :lg="6"
          class="card-panel-col"
          v-for="(item, index) in balances"
          :key="index"
        >
          <LedgerBalance
            :projectUID="item.project_uid"
            :customerUID="customerUID"
            :ledgerID="item.ledger_id"
            :apiMode="apiMode"
          />
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>
<script>
import { getProjectBalance, getCustomerBalance } from "@/api/bank-account";
import LedgerBalance from "./ledger-balance";
import { mapGetters } from "vuex";
export default {
  components: {
    LedgerBalance,
  },
  computed:{
    ...mapGetters([
      "company_name",
      "company_uid",
    ]),
  },
  props: {
    projectUID: String,
    customerUID: String,
    bankAccountNumbers: Number,
    apiMode: String,
    showAccountNumber: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      loading: false,
      balances: [],
      balanceLedger: [],
    };
  },
  methods: {
    getProjectBalanceData() {
      this.loading = true;
      getProjectBalance(this.projectUID).then(({ result, data }) => {
        if (result && data) {
          this.balances = data
        }
      });
    },
    getCustomerBalanceData() {
      this.loading = true;
      getCustomerBalance(this.customerUID).then(({ result, data }) => {
        if (result && data) {
          this.balances = data;
        }
      });
    },

    Reload() {
      this.balances = []
      this.balanceLedger = []
      if (this.apiMode === "project") {
        this.getProjectBalanceData();
      }
      if (this.apiMode === "customer") {
        this.getCustomerBalanceData();
      }
    },
    gotoProject() {
      const route = this.$route;
      if (route.name === "ProjectCustomer") {
        window.location = `/project/${this.projectUID}?tab=project`;
      } else {
        this.$router.push(`/project/${this.projectUID}`);
      }
    },
  },
  created() {
    this.Reload()
  },
};
</script>

<style lang="scss" scoped>
.panel-group {
  margin-top: 18px;

  .card-panel-col {
    margin-bottom: 18px;
  }

  .card-panel {
    height: 108px;
    font-size: 12px;
    position: relative;
    overflow: hidden;
    color: #666;
    background: #fff;
    box-shadow: 4px 4px 40px rgba(0, 0, 0, 0.05);
    border-color: rgba(0, 0, 0, 0.05);


    .icon-people {
      color: #40c9c6;
    }

    .card-panel-icon-wrapper {
      float: left;
      margin: 14px 0 0 6px;
      padding: 16px;
      transition: all 0.38s ease-out;
      border-radius: 6px;

    }

    .card-panel-icon {
      float: left;
      font-size: 48px;
    }

    .card-panel-description {
      float: right;
      font-weight: bold;
      margin: 10px;
      margin-left: 0px;

      .card-panel-text {
        line-height: 18px;
        color: rgba(0, 0, 0, 0.45);
        font-size: 16px;
        margin-bottom: 12px;
        text-align: right;
      }

      .card-panel-num {
        font-size: 20px;
        text-align: right;
        margin-bottom: 7px;
      }
      .card-panel-acc {
        text-align: right;
        margin-bottom: 3px;
      }
      .card-panel-type {
        text-align: right;
      }
    }
  }
}

@media (max-width: 550px) {
  // .card-panel-description {
  //   display: none;
  // }

    .card-panel-icon-wrapper {
    float: none !important;
    width: 0px;
    height: 0px;
    padding: 0 !important;
    margin: 0 !important;

    .svg-icon {
      display: block;
      margin: 0px auto !important;
      float: none !important;
    }
  }
}
</style>
